
/* ####### No video below
// src/components/VideoCard.js
import React, { useRef } from 'react';
import './VideoCard.css';
import { Link } from 'react-router-dom';

const VideoCard = ({ video, darkMode, className }) => {
    const videoRef = useRef(null);

    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    const cardContent = (
        <div 
            className={`video-card ${darkMode ? 'dark' : ''} ${className}`} 
            onMouseEnter={handleMouseEnter} 
            onMouseLeave={handleMouseLeave}
        >
            <video
                ref={videoRef}
                src={video.src}
                poster={video.thumbnail}
                className="video-element"
                muted
                loop
                playsInline
                preload="metadata"
            />
            <div className="overlay">
                <div className="overlay-header">
                    <h3>{video.title}</h3>
                </div>
                <div className="overlay-description">
                    <p>{video.description}</p>
                </div>
            </div>
        </div>
    );

    return video.link ? (
        <Link to={video.link} style={{ textDecoration: 'none', color: 'inherit' }}>
            {cardContent}
        </Link>
    ) : (
        cardContent
    );
};

export default VideoCard;

*/

import React, { useRef, useEffect } from 'react';
import '../styles/VideoCard.css';
import { Link } from 'react-router-dom';

const VideoCard = ({ video, darkMode, className }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        // Ensure video starts playing on load
        if (videoRef.current) {
            videoRef.current.play();
        }
    }, []);

    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.pause(); // Pause on hover
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.play(); // Resume playing when mouse leaves
        }
    };

    const cardContent = (
        <div 
            className={`video-card ${darkMode ? 'dark' : ''} ${className}`} 
            onMouseEnter={handleMouseEnter} 
            onMouseLeave={handleMouseLeave}
        >
            <video
                ref={videoRef}
                src={video.src}
                poster={video.thumbnail}
                className="video-element"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
            />
            <div className="overlay">
                <div className="overlay-header">
                    <h3>{video.title}</h3>
                </div>
                <div className="overlay-description">
                    <p>{video.description}</p>
                </div>
            </div>
        </div>
    );

    return video.link ? (
        <Link to={video.link} style={{ textDecoration: 'none', color: 'inherit' }}>
            {cardContent}
        </Link>
    ) : (
        cardContent
    );
};

export default VideoCard;
